// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout-module--wrapper--3Z9cY","header":"Layout-module--header--26_6V"};